module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('side-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shouldShowNavigation),
      expression: "shouldShowNavigation"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('nav-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shouldShowNavigation),
      expression: "shouldShowNavigation"
    }]
  }), _vm._v(" "), _c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a2256c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main.vue
// module id = 1061
// module chunks = 23